import { superAxios } from '../../utils/axios';
import axios from '../../utils/axios';
export const FETCH_SUBSIDIARIES_SUCCESS = 'FETCH_SUBSIDIARIES_SUCCESS';
export const ADD_SUBSIDIARIES_SUCCESS = 'ADD_SUBSIDIARIES_SUCCESS';
export const EDIT_SUBSIDIARIES_SUCCESS = 'EDIT_SUBSIDIARIES_SUCCESS';

export const SUBSIDIARIES_ERROR = 'SUBSIDIARIES_ERROR';

const fetchAdminSubsidiariesEndpoint = `${process.env.REACT_APP_API_URL}subsidiaries`;
const fetchSubsidiariesEndpoint = (companyId) => `${process.env.REACT_APP_API_URL}super/company/${companyId}/subsidiaries`;
const postSubsidiaryEndpoint = (companyId) => `${process.env.REACT_APP_API_URL}super/company/${companyId}/subsidiary`;
const putSubsidiaryEndpoint = (companyId, subsidiaryId) => `${process.env.REACT_APP_API_URL}super/company/${companyId}/subsidiary/${subsidiaryId}`;

export const fetchSubsidiariesSuccess = (subsidiaries) => (dispatch) => dispatch({
  type: FETCH_SUBSIDIARIES_SUCCESS,
  subsidiaries
});

export const subsidiariesError = (error) => (dispatch) => dispatch({
  type: SUBSIDIARIES_ERROR,
  error
});

export const fetchSubsidiaries = (companyId) => async (dispatch) => {
  try {
    const response = await superAxios.get(fetchSubsidiariesEndpoint(companyId));
    dispatch(fetchSubsidiariesSuccess(response.data.data));

    return response.data;
  } catch (error) {
    dispatch(subsidiariesError(error));
  }
};

export const fetchAdminSubsidiaries = () => async (dispatch) => {
  try {
    const response = await axios.get(fetchAdminSubsidiariesEndpoint);
    dispatch(fetchSubsidiariesSuccess(response.data.data));

    return response.data;
  } catch (error) {
    dispatch(subsidiariesError(error));
  }
};

export const addSubsidiarySuccess = (newSubsidiary) => (dispatch) => dispatch({
  type: ADD_SUBSIDIARIES_SUCCESS,
  newSubsidiary
});

export const addSubsidiary = (newSubsidiary, companyId) => async (dispatch) => {
  try {
    await superAxios.post(postSubsidiaryEndpoint(companyId), { ...newSubsidiary });

    dispatch(addSubsidiarySuccess(newSubsidiary));
    dispatch(fetchSubsidiaries(companyId));
  } catch (error) {
    throw new Error(error); // temp solution untill the toast will be written in redux
  }
};

export const editSubsidiarySuccess = (subsidiary) => (dispatch) => dispatch({
  type: EDIT_SUBSIDIARIES_SUCCESS,
  subsidiary
});

export const editSubsidiary = (subsidiary, companyId) => async (dispatch) => {
  try {
    const filterSubsidiaryData = ({
      billingAddress,
      billingEmails,
      legalName,
      name,
      payrollEmails,
      taxId,
      identifier
    }) => ({
      billingAddress,
      billingEmails,
      legalName,
      name,
      payrollEmails,
      taxId,
      identifier
    });

    await superAxios.put(
      putSubsidiaryEndpoint(companyId, subsidiary?.id),
      filterSubsidiaryData(subsidiary)
    );

    dispatch(editSubsidiarySuccess(subsidiary));
  } catch (error) {
    throw new Error(error); // temp solution untill the toast will be written in redux
  }
};
